import { DataService } from "@/services/data";
import { handle_error } from "@/utils/wretch";
import { Navigate, RouteObject } from "react-router-dom";

const ScrapingRoute: RouteObject = {
    path: "offres",
    children: [
        {
            index: true,
            element: <Navigate to="/alternance/entreprises" replace />
        },
        {
            id: "apprenticeship-scraping-offer-detail",
            path: ":offerId",
            action: async ({ params, request }) => {
                const offerId = params.offerId;
                const data = await request.json();
                const url = new URL(request.url);
                const action = url.searchParams.get("action");
                if (action) {
                    try {
                        const content = await DataService.client.url(`/apprenticeship/scraping/offers/${offerId}/${action}/`).post(data).json();
                        return { success: true, content: content };
                    } catch (error) {
                        return handle_error(error);
                    }
                }
                return {};
            }
        }
    ]
};

export default ScrapingRoute;
